import { gql } from "@apollo/client";

const GET_USER = gql`
  query user($id: ID!) {
    user(id: $id) {
      id
      email
      type
      driver {
        id
        firstName
        lastName
        clients {
          id
          name
          type
          img
        }
        currentVehicle {
          id
          description
          plate
          brand
          modelYear
          city
          idInvers
          idFourTrack
          vin
          transmission
          type
        }
        service {
          id
          pickupDate
          type
          client {
            id
            name
            img
            type
          }
          location {
            name
            address {
              fullName
              city
              location {
                coordinates
              }
            }
          }
          start
          assignedParcels
        }
      }
      client {
        id
        name
        type
        integrations {
          conekta {
            customerId
          }
          shopify {
            domain
          }
          mercadoLibre {
            userId
          }
        }
        balance {
          amount
        }
        basePrice {
          amount
        }
        kmExtraPrice {
          amount
        }
        destinationExtraPrice {
          amount
        }
        img
        apiKey {
          id
        }
      }
      lead {
        id
        firstName
        zone {
          id
          name
        }
        lastName
        visitDate
        visitDepot
        documents {
          profilePicture
          licence
          INE
        }
      }
      support {
        id
        firstName
        lastName
        defaultMessage
        partner
      }
      clientLead {
        id
        name
        clientName
        basePrice {
          amount
        }
        kmExtraPrice {
          amount
        }
        destinationExtraPrice {
          amount
        }
      }
      owner {
        id
        firstName
        lastName
      }
      monitor {
        id
        firstName
        lastName
      }
      lastMile {
        id
        zone {
          id
        }
      }
      cordinator {
        id
        firstName
        lastName
        zone {
          id
          name
          centerpoint {
            location {
              coordinates
            }
          }
        }
      }
    }
  }
`;

export { GET_USER };
